module.exports = __webpack_public_path__ + "static/york_main_2-32a89f0ce35081616bb064847ce5e54b.jpg";